"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationService_1 = require("./ValidationService");
var FieldsetValidationHandler = /** @class */ (function () {
    function FieldsetValidationHandler(element) {
        var _this = this;
        this.hasDocumentListener = false;
        this.documentFocusInRef = undefined;
        Object.assign(this);
        this.element = element;
        element.addEventListener('focusin', function (event) { return _this.onFocusIn(event); });
        this.element.querySelectorAll('input').forEach(function (childElement) { return childElement.setAttribute('required', ''); });
    }
    FieldsetValidationHandler.prototype.hasFocusableTarget = function (target) {
        return target ? Array.from(this.element.querySelectorAll('input, label')).some(function (element) { return element === target; }) : false;
    };
    FieldsetValidationHandler.prototype.onFocusIn = function (event) {
        // IE11 (not Chrome / FF) trigger focusin-event on legends and other elements inside the fieldset
        // So we need to check the event target, if it's focusable.
        if (this.hasFocusableTarget(event.target) && !this.hasDocumentListener) {
            this.documentFocusInRef = this.documentFocusIn.bind(this);
            document.addEventListener('focusin', this.documentFocusInRef);
            document.addEventListener('click', this.documentFocusInRef);
            this.hasDocumentListener = true;
        }
    };
    FieldsetValidationHandler.prototype.documentFocusIn = function (event) {
        ValidationService_1.ValidationService.setState(this.element.id, { touched: true });
        this.element.querySelectorAll('input').forEach(function (childElement) { return ValidationService_1.ValidationService.setState(childElement.id, { touched: true }); });
        if (!this.hasFocusableTarget(event.target)) {
            this.removeEventListeners();
        }
        else if (event.target.checked) {
            this.validateFieldsetAndChildren();
        }
    };
    FieldsetValidationHandler.prototype.removeEventListeners = function () {
        if (this.hasDocumentListener && this.documentFocusInRef) {
            document.removeEventListener('focusin', this.documentFocusInRef);
            document.removeEventListener('click', this.documentFocusInRef);
            this.hasDocumentListener = false;
            this.validateFieldsetAndChildren();
        }
    };
    FieldsetValidationHandler.prototype.validateFieldsetAndChildren = function () {
        var validatableElements = document.querySelectorAll("fieldset#" + this.element.id + ", #" + this.element.id + " input");
        validatableElements.forEach(function (element) {
            if (element.id) {
                ValidationService_1.ValidationService.validateElement(element.id);
            }
        });
    };
    return FieldsetValidationHandler;
}());
exports.FieldsetValidationHandler = FieldsetValidationHandler;
// ? Needed for Styleguidist to pickup the documentation.
exports.default = {};
//# sourceMappingURL=FieldsetValidationHandler.js.map